/** Row density of a long admin table (design §6.6: 52 / 40 px, the choice is remembered).
 *  Per browser only: localStorage can be blocked or throw (private mode), the table then simply
 *  starts comfortable. */
import { useCallback, useState } from 'react'

export type Density = 'comfortable' | 'compact'

const key = (scope: string) => `aivy-admin:density:${scope}`

export function readDensity(scope: string): Density {
  try {
    return window.localStorage.getItem(key(scope)) === 'compact' ? 'compact' : 'comfortable'
  } catch {
    return 'comfortable'
  }
}

export function useDensity(scope: string): [Density, (d: Density) => void] {
  const [density, setState] = useState<Density>(() => readDensity(scope))
  const set = useCallback(
    (d: Density) => {
      setState(d)
      try {
        window.localStorage.setItem(key(scope), d)
      } catch {
        // storage blocked: the choice lives until the page is left
      }
    },
    [scope],
  )
  return [density, set]
}
